import request from '@/utils/request'

export function getTheme() {
  return request({
    url: '/system/config/theme',
    method: 'get',
    headers: { repeatSubmit: false }
  })
}

export function updateTheme(data) {
  return request({
    url: '/system/config/theme',
    method: 'put',
    data
  })
}
